import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box } from "@mui/material";
import { DataGridPremium, GridToolbar } from "@mui/x-data-grid-premium";

const PNRTicketReport = ({ startDate, endDate, token }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/reports/pnr/TicketReport?startDate=${startDate}&endDate=${endDate}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        // Map new data structure
        const rows = response.data.data.map((row, idx) => ({
          id: idx + 1,
          create_date: row.create_date,
          New: row.New,
          New_Modified: row["New + Modified"],
          New_Cancelled: row["New + Cancelled"],
          New_Modified_Cancelled: row["New, Modified + Cancelled"],
          total_pnrs: row.total_pnrs,
          actions: row.actions,
          new_tickets: row.new_tickets,
          active: row.active,
          pending: row.pending,
          resolved: row.resolved,
        }));

        setData(rows);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (startDate && endDate) {
      fetchData();
    }
  }, [startDate, endDate, token]);

  const columns = [
    { field: "create_date", headerName: "Create Date", flex: 1 },
    { field: "New", headerName: "New", flex: 1, type: "number" },
    {
      field: "New_Modified",
      headerName: "New + Modified",
      flex: 1,
      type: "number",
    },
    {
      field: "New_Cancelled",
      headerName: "New + Cancelled",
      flex: 1,
      type: "number",
    },
    {
      field: "New_Modified_Cancelled",
      headerName: "New, Modified + Cancelled",
      flex: 1,
      type: "number",
    },
    { field: "total_pnrs", headerName: "Total PNRs", flex: 1, type: "number" },
    { field: "actions", headerName: "Actions", flex: 1, type: "number" },
    {
      field: "new_tickets",
      headerName: "New Tickets",
      flex: 1,
      type: "number",
    },
    { field: "active", headerName: "Active", flex: 1, type: "number" },
    { field: "pending", headerName: "Pending", flex: 1, type: "number" },
    { field: "resolved", headerName: "Resolved", flex: 1, type: "number" },
  ];

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!data || data.length === 0) return <h3>No Data Available</h3>;

  return (
    <Box sx={{ height: 600, width: "100%", marginTop: 2 }}>
      <DataGridPremium
        rows={data}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newSize) => setPageSize(newSize)}
        slots={{ toolbar: GridToolbar }}
        pageSizeOptions={[5, 10, 15, 20]}
        disableRowSelectionOnClick
        getRowId={(row) => row.id}
      />
    </Box>
  );
};

export default PNRTicketReport;
